import React, { FC } from "react";

type CaretDownProps = {
  className?: string;
};

const CaretDown: FC<CaretDownProps> = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="16"
      viewBox="0 0 13 16"
      fill="none"
      className={className}
    >
      <g clipPath="url(#clip0_3098_609)">
        <path
          d="M3.39136 6L7.39136 10L11.3914 6"
          stroke="#123333"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath>
          <rect
            width="12"
            height="16"
            fill="white"
            transform="translate(0.391357)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export default CaretDown;
